export default {
  methods: {
    mapLayerSnowmakingFangunsAdd() {
      this.initPollSnowmakingFanguns();

      this.map.addSource("fanguns", {
        type: "geojson",
        data: this.computedSnowmakingFangunsGeoJson
      });

      // POLECATS
      // Auto 30 layer/icon
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto30Polecat.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-auto-30-polecat", image);

          this.map.addLayer({
            id: "fanguns-auto-30-polecat",
            filter: [
              "all",
              ["==", "amps", "30"],
              ["==", "gun_type", "Auto"],
              ["==", "gun_style", "Polecat"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-auto-30-polecat",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("fanguns-auto-30-polecat", "marker-layer-points");
        }
      );

      // Auto 60 layer/icon
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto60Polecat.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-auto-60-polecat", image);

          this.map.addLayer({
            id: "fanguns-auto-60-polecat",
            filter: [
              "all",
              ["==", "amps", "60"],
              ["==", "gun_type", "Auto"],
              ["==", "gun_style", "Polecat"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-auto-60-polecat",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("fanguns-auto-60-polecat", "marker-layer-points");
        }
      );

      // Manual 30 layer/icon
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Manual30Polecat.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-manual-30-polecat", image);

          this.map.addLayer({
            id: "fanguns-manual-30-polecat",
            filter: [
              "all",
              ["==", "amps", "30"],
              ["==", "gun_type", "Manual"],
              ["==", "gun_style", "Polecat"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-manual-30-polecat",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "fanguns-manual-30-polecat",
            "marker-layer-points"
          );
        }
      );

      // Manual 60 layer/icon
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Manual60Polecat.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-manual-60-polecat", image);

          this.map.addLayer({
            id: "fanguns-manual-60-polecat",
            filter: [
              "all",
              ["==", "amps", "60"],
              ["==", "gun_type", "Manual"],
              ["==", "gun_style", "Polecat"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-manual-60-polecat",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "fanguns-manual-60-polecat",
            "marker-layer-points"
          );
        }
      );

      // Auto 60 layer/icon
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto60Wizzard.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-auto-60-wizzard", image);

          this.map.addLayer({
            id: "fanguns-auto-60-wizzard",
            filter: [
              "all",
              ["==", "amps", "60"],
              ["==", "gun_type", "Auto"],
              ["==", "gun_style", "Wizzard"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-auto-60-wizzard",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("fanguns-auto-60-wizzard", "marker-layer-points");
        }
      );

      // Manual 30 layer/icon (Wizkid..)
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Manual30Wizzard.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-manual-30-wizzard", image);

          this.map.addLayer({
            id: "fanguns-manual-30-wizzard",
            filter: [
              "all",
              ["==", "amps", "30"],
              ["==", "gun_type", "Manual"],
              ["==", "gun_style", "Wizzard"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-manual-30-wizzard",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.addLayer({
            id: "fanguns-manual-30-wizkid",
            filter: [
              "all",
              ["==", "amps", "30"],
              ["==", "gun_type", "Manual"],
              ["==", "gun_style", "WizKid"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-manual-30-wizzard",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "fanguns-manual-30-wizzard",
            "marker-layer-points"
          );
          this.map.moveLayer("fanguns-manual-30-wizkid", "marker-layer-points");
        }
      );

      // Manual 60 layer/icon
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Manual60Wizzard.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-manual-60-wizzard", image);

          this.map.addLayer({
            id: "fanguns-manual-60-wizzard",
            filter: [
              "all",
              ["==", "amps", "60"],
              ["==", "gun_type", "Manual"],
              ["==", "gun_style", "Wizzard"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-manual-60-wizzard",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "fanguns-manual-60-wizzard",
            "marker-layer-points"
          );
        }
      );

      // T40
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto30T40.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-auto-30-t40", image);

          this.map.addLayer({
            id: "fanguns-auto-30-t40",
            filter: [
              "all",
              ["==", "amps", "30"],
              ["==", "gun_type", "Auto"],
              ["==", "gun_style", "T40 Techno"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-auto-30-t40",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("fanguns-auto-30-t40", "marker-layer-points");
        }
      );

      // HKD FAN
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto60HKD.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-auto-60-hkd", image);

          this.map.addLayer({
            id: "fanguns-auto-60-hkd",
            filter: [
              "all",
              ["==", "gun_style", "HKD Fan"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-auto-60-hkd",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("fanguns-auto-60-hkd", "marker-layer-points");
        }
      );

      // SUPER PUMA FAN
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto60SuperPuma.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-auto-60-superpuma", image);

          this.map.addLayer({
            id: "fanguns-auto-60-superpuma",
            filter: [
              "all",
              ["==", "gun_style", "Super Puma"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-auto-60-superpuma",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "fanguns-auto-60-superpuma",
            "marker-layer-points"
          );
        }
      );

      // PUMA CARRIAGE
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/Auto60Puma.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-auto-60-puma", image);

          this.map.addLayer({
            id: "fanguns-auto-60-puma",
            filter: [
              "all",
              ["==", "gun_style", "Puma"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-auto-60-puma",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("fanguns-auto-60-puma", "marker-layer-points");
        }
      );

      // AutoTWR 60 layer/icon
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/fanguns/AutoTWR60.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-fanguns-autotwr-60", image);

          this.map.addLayer({
            id: "fanguns-autotwr-60",
            filter: [
              "all",
              ["==", "amps", "60"],
              ["==", "gun_type", "AutoTWR"],
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"]
            ],
            type: "symbol",
            source: "fanguns",
            layout: {
              "icon-image": "icon-snowmaking-fanguns-autotwr-60",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("fanguns-autotwr-60", "marker-layer-points");
        }
      );
    },
    // method to remove all layers and the source
    mapLayerSnowmakingFangunsRemove() {
      this.cancelPollSnowmakingFanguns();
      this.map.removeImage("icon-snowmaking-fanguns-manual-30-polecat");
      this.map.removeImage("icon-snowmaking-fanguns-manual-60-polecat");
      this.map.removeImage("icon-snowmaking-fanguns-auto-30-polecat");
      this.map.removeImage("icon-snowmaking-fanguns-auto-60-polecat");
      this.map.removeImage("icon-snowmaking-fanguns-manual-30-wizzard");
      this.map.removeImage("icon-snowmaking-fanguns-manual-60-wizzard");
      this.map.removeImage("icon-snowmaking-fanguns-auto-60-wizzard");
      this.map.removeImage("icon-snowmaking-fanguns-auto-30-t40");
      this.map.removeImage("icon-snowmaking-fanguns-auto-60-hkd");
      this.map.removeImage("icon-snowmaking-fanguns-autotwr-60");
      this.map.removeLayer("fanguns-manual-30-polecat");
      this.map.removeLayer("fanguns-manual-60-polecat");
      this.map.removeLayer("fanguns-auto-30-polecat");
      this.map.removeLayer("fanguns-auto-60-polecat");
      this.map.removeLayer("fanguns-manual-30-wizzard");
      this.map.removeLayer("fanguns-manual-30-wizkid");
      this.map.removeLayer("fanguns-manual-60-wizzard");
      this.map.removeLayer("fanguns-auto-60-wizzard");
      this.map.removeLayer("fanguns-auto-30-t40");
      this.map.removeLayer("fanguns-auto-60-hkd");
      this.map.removeLayer("fanguns-auto-60-superpuma");
      this.map.removeLayer("fanguns-auto-60-puma");
      this.map.removeLayer("fanguns-autotwr-60");
      this.map.removeSource("fanguns");
    },
    // method to create the geojson polling
    initPollSnowmakingFanguns() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/snowmaking/fanguns",
        dept: "snowmaking",
        layer: "fanguns",
        token: this.computedAuthToken
      });
      this.pollSnowmakingFangunsInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/fanguns",
          dept: "snowmaking",
          layer: "fanguns",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    // method to cancel poll
    cancelPollSnowmakingFanguns() {
      this.pollSnowmakingFangunsInterval = clearInterval(
        this.pollSnowmakingFangunsInterval
      );
    }
  },
  computed: {
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    // the geojson
    computedSnowmakingFangunsGeoJson() {
      return this.$store.state.mapLayers.snowmaking.layers.fanguns.geojson;
    },
    // visibility
    computedSnowmakingFangunsMapVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.fanguns.visibility
        .mapView;
    },
    // grabs the interval from the vuex state
    computedInterval() {
      return this.$store.state.general.interval;
    },
    computedSingleView() {
      return this.$store.state.mapLayers.snowmaking.layers.fanguns.visibility
        .singleView;
    }
  },
  watch: {
    // watches the vuex state and if geojson changes removes then re-adds layers/source
    "$store.state.mapLayers.snowmaking.layers.fanguns.geojson": {
      handler() {
        if (this.computedSnowmakingFangunsMapVisibility) {
          this.mapLayerSnowmakingFangunsRemove();
          this.mapLayerSnowmakingFangunsAdd();
        }
      }
    },
    // watches the vuex state of visibility and adds or removes the layer/source
    "$store.state.mapLayers.snowmaking.layers.fanguns.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSnowmakingFangunsAdd();
      } else {
        this.mapLayerSnowmakingFangunsRemove();
      }
    }
  },
  beforeDestroy() {
    // cancels poll on component destroy
    this.cancelPollSnowmakingFanguns();
  }
};
